import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { GetTeamMembersVm } from './get-team-members.vm';

export const getTeamMembers = async (teamId: string, warehouseId: string, offset: string, callback: CallbackObject<GetTeamMembersVm>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            limit: 50,
            offset: offset,
            warehouseId: warehouseId,
        }
    };

    try {
        const res: AxiosResponse = await instance.get(`/management/teams/${teamId}/members`, config);
        callback.success(plainToClass(GetTeamMembersVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
